export const getVideoSetting = (videoSize, videoFrameRate) => {
  let setting
  if (!videoSize || !videoFrameRate) {
    return (setting = "720p_5")
  } else if (
    videoSize[0] === 640 &&
    videoSize[1] === 480 &&
    videoFrameRate[0] === 15
  ) {
    return (setting = "480p")
  } else {
    return (setting = "480p")
  }
}
